import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['verificationCode', 'button'];
  connect() {
    this.buttonTarget.setAttribute('disabled', true);
    this.validateForm();
  }

  validateForm() {
    let status = false;
    if (this.validateVerificationCode()) {
      status = true;
      this.buttonTarget.removeAttribute('disabled');
    } else {
      this.buttonTarget.setAttribute('disabled', true);
    }
    return status;
  }

  validateVerificationCode() {
    const value = this.verificationCodeTarget.value;
    return value && value.length >= 4;
  }
}
